import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Masuk from "./masuk";
import Forgot from "./lupa";
import OTP from "./lupa/otp";
import Reset from "./lupa/reset";
import LoginToken from "./loginToken";
import PrivateRoute from "../../components/routing/PrivateRoute";

function Login() {
  return (
    <Switch>
      <PrivateRoute path="/login/reset" component={Reset} />
      <Route path="/login/forgot/:phone/:expired" component={OTP} />
      <Route path="/login/forgot" component={Forgot} />
      <Route exact path="/login" component={Masuk} />
      <Route path="/login/:loginToken" component={LoginToken} />
      <Redirect to="/login" />
    </Switch>
  );
}

export default Login;
